import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect, useRef } from 'react';
import './addressMap.css';


// CRIA UM PIN DE MAPA NA COR DA EMPRESA (EVITA DEPENDER DOS ÍCONES PADRÃO DO LEAFLET)
function buildMarkerIcon(color) {
    const svg = `
        <svg width="30" height="42" viewBox="0 0 30 42" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 0C6.7 0 0 6.7 0 15c0 11.25 15 27 15 27s15-15.75 15-27C30 6.7 23.3 0 15 0z" fill="${color}"/>
            <circle cx="15" cy="15" r="6" fill="#fff"/>
        </svg>
    `;

    return L.divIcon({
        html: svg,
        className: 'address-map-pin',
        iconSize: [30, 42],
        iconAnchor: [15, 42],
    });
}


export default function AddressMap({ latitude, longitude, color }) {
    const containerRef = useRef(null);
    const mapRef = useRef(null);

    useEffect(() => {
        if (!latitude || !longitude || !containerRef.current) return;

        const map = L.map(containerRef.current, {
            center: [latitude, longitude],
            zoom: 16,
            scrollWheelZoom: false,
        });

        mapRef.current = map;

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            maxZoom: 19,
        }).addTo(map);

        L.marker([latitude, longitude], { icon: buildMarkerIcon(color ?? '#005586') }).addTo(map);

        // GARANTE O DIMENSIONAMENTO CORRETO CASO O CONTAINER AINDA ESTEJA SE AJUSTANDO NO LAYOUT
        setTimeout(() => map.invalidateSize(), 150);

        return () => {
            map.remove();
            mapRef.current = null;
        };
    }, [latitude, longitude, color]);

    if (!latitude || !longitude) return null;

    return <div ref={containerRef} className="address-map" />;
}
